import { render, staticRenderFns } from "./PhoneStepDetailPassword.vue?vue&type=template&id=47fb13d6&scoped=true"
import script from "./PhoneStepDetailPassword.vue?vue&type=script&lang=js"
export * from "./PhoneStepDetailPassword.vue?vue&type=script&lang=js"
import style0 from "./PhoneStepDetailPassword.vue?vue&type=style&index=0&id=47fb13d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb13d6",
  null
  
)

export default component.exports